import { MotionConfig } from "framer-motion";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { queryClient } from "@/lib/queryClient";
import { router } from "@/router";
import { EASE } from "@/motion/variants";

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      {/*
        `reducedMotion="user"` makes every Motion component in the tree honour
        prefers-reduced-motion automatically, so no component branches on it.
      */}
      <MotionConfig reducedMotion="user" transition={{ duration: 0.28, ease: EASE }}>
        <RouterProvider router={router} />
      </MotionConfig>
    </QueryClientProvider>
  );
}
